/**
 * Cart Summary Utility Functions
 *
 * Provides helper functions for calculating cart totals and filtering data.
 */
import { COUPONS_EXEMPT_FROM_LIMIT } from '../../constants';
import { CartItemResponse, CartCouponResponse, CartResponseResponse } from '../../model';
import { getFilteredHalloweenPromoItems } from '../campaign';

type Cart = CartResponseResponse['cart'];

export const calculateTotalQuantity = (items: CartItemResponse[]): number => {
  return items.reduce((prev, curr) => prev + curr.quantity, 0);
};

export const calculateTotalPrice = (items: CartItemResponse[]): number => {
  const filteredItems = getFilteredHalloweenPromoItems(items);
  return filteredItems.reduce((prev, curr) => prev + curr.price.price * curr.quantity, 0);
};

export const filterSystemCoupons = (coupons: CartCouponResponse[]): CartCouponResponse[] => {
  return coupons.filter((coupon) => !COUPONS_EXEMPT_FROM_LIMIT.includes(coupon.code));
};

export const getCartSummary = (cart?: Cart) => {
  const items = cart?.item ?? [];
  const coupons = cart?.coupons ?? [];
  const filteredCoupons = filterSystemCoupons(coupons);

  const isFreeShipping = cart?.shippingRates?.length !== 0 && cart?.shippingRates?.[0]?.price === 0;

  return {
    items,
    coupons,
    filteredCoupons,
    orderTotal: cart?.totals.total ?? 0,
    totalTax: cart?.totals.totalCustom ?? 0,
    discountTotal: cart?.totals.totalDiscount ?? 0,
    totalQuantity: calculateTotalQuantity(items),
    totalPrice: calculateTotalPrice(items),
    isFreeShipping,
  };
};
